// parentesco
const CONJUGE = 'Cônjuge';
const CONVIVENTE = 'Convivente';
const FILHO = 'Filho(a)';
const PAI = 'Pai';
const MAE = 'Mãe';
const ENTEADO = 'Enteado(a)';
const IRMAO = 'Irmão(ã)';
const NETO = 'Neto(a)';
const BISNETO = 'Bisneto(a)';
const AVO = 'Avô(ó)';
const BISAVO = 'Bisavô(ó)';
const MENOR_ASSISTIDO = 'Menor assistido';
const INCAPAZ = 'Pessoa absolutamente incapaz';
const SOGRO = 'Sogro(a)';
const GENRO = 'Genro';
const NORA = 'Nora';

const parentescoOptions = [
  CONJUGE,
  CONVIVENTE,
  FILHO,
  PAI,
  MAE,
  ENTEADO,
  IRMAO,
  NETO,
  BISNETO,
  AVO,
  BISAVO,
  MENOR_ASSISTIDO,
  INCAPAZ,
  SOGRO,
  GENRO,
  NORA,
];

// situação
const MENOR_IGUAL_21 = 'Até 21 anos';
const ESPECIAL = 'Especial';
const UNIVERSITARIO = 'Universitário';

const situacaoOptions = [MENOR_IGUAL_21, ESPECIAL, UNIVERSITARIO];

export const parentescoSituacao = {
  constantsParentesco: {
    CONJUGE,
    CONVIVENTE,
    FILHO,
    PAI,
    MAE,
    IRMAO,
    ENTEADO,
    NETO,
    BISNETO,
    AVO,
    BISAVO,
    MENOR_ASSISTIDO,
    INCAPAZ,
    SOGRO,
    GENRO,
    NORA,
  },
  constantsSituacao: {
    MENOR_IGUAL_21,
    ESPECIAL,
    UNIVERSITARIO,
  },
  options: { parentescoOptions, situacaoOptions },
};
